import { type FC } from 'react'
import { Modal } from '../../../components/Modal/Modal'

interface SkipMeetingPlatformModalProps {
  onConfirm: () => void
  onCancel: () => void
}

export const SkipMeetingPlatformModal: FC<SkipMeetingPlatformModalProps> = ({ onConfirm, onCancel }) => (
  <Modal
    show
    onHide={onCancel}
    header={<h5 className='mb-0'>Skip choosing meeting platform?</h5>}
    headerBodySeparator
    body={<div className='paragraph-small'>Bookings will go to your calendar without a join link. You can choose a platform later in Scheduling settings.</div>}
    showFooterActions
    footerPrimaryActionTitle='Skip this step'
    footerSecondaryActionTitle='Cancel'
    onFooterPrimaryAction={onConfirm}
    onFooterSecondaryAction={onCancel}
  />
)
